import { Button } from "components/Button";
import React, { memo, useState } from "react";
import lineGreen from "assets/images/lineGreen.svg";
import rocketGreen from "assets/images/rocketGreen.svg";
import config from "config";
import HubSpotForm from "components/HubSpotForm";

interface ICardProps extends React.HTMLAttributes<HTMLDivElement> {
  isPremium: boolean | undefined;
  classNames?: {
    title?: string;
  };
}

function AdvHeader({ isPremium = false }: ICardProps) {
  const [showForm, setShowForm] = useState(false);
  
  return (
    <>
      <div>
        {!isPremium && (
          <section className="w-full h-[48px] bg-tablePrimary">
            <header className="w-full pr-4 pl-4 mr-auto ml-auto h-[48px] ">
              <div className="flex align-items-center justify-center justify-content-center h-[48px]">
                <div className="flex justify-content-center h-[48px] items-center">
                  <img
                    src={lineGreen}
                    alt="lineGreen"
                    className="hidden xl:block w-[220px]"
                  />
                  <img
                    src={rocketGreen}
                    alt="rocketGreen"
                    className="hidden xl:block"
                  />
                  <h2 className="text hidden md:inline align-self-center font-bold leading-5 text-[14px] text-primary mx-[20px] ">
                    View All {config.PLATFORM_NAME} Technology Data Points
                  </h2>
                  <Button
                    customPaddings
                    className="cursor-pointer inline-block ml-4 w-[140px] h-[30px] justify-center font-bold rounded-[4px] text-[12px] items-center text-center whitespace-no-wrap align-middle select-none text-base leading-normal text-[#FFFFFF] bg-[#28C18A] hover:text-white hover:bg-[#31414E] hover:border-primary align-self-center opacity-100"
                    onClick={() => {
                      setShowForm(true)
                    }}
                  >
                    Premium Access
                  </Button>
                  <img
                    src={lineGreen}
                    alt="lineGreen"
                    className="hidden xl:block w-[220px]"
                  />
                </div>
              </div>
            </header>
          </section>
        )}
      </div>{" "}

      <HubSpotForm setShow={setShowForm} show={showForm} />
    </>
  );
}
AdvHeader.defaultProps = {
  className: " flex flex-col rounded overflow-hidden shadow-lg bg-primary",
};
export default memo(AdvHeader);
